import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Row } from "react-bootstrap";
import SarlaftPJuridica from "./sarlaftPJuridica";
import SarlaftPNatural from "./sarlaftPNatural";
import Header from "../../components/Index/Header";
import Footer from "../../components/Index/Footer";

const Sarlaft = ({ }) => {
  const [type, setType] = useState(null);
  const [containerClass, setContainerClass] = useState("containerBody");
  const [backgroundClass, setBackgroundClass] = useState("backgroundDark");
  const [colComponent, setColComponent] = useState("col-12 col-md-6");

  const selectedType = (option) => {
    window.scrollTo(0, 0);
    setType(option);
    setContainerClass("containerBody2 marginTop");
    setBackgroundClass("");
    setColComponent("col-10 pt-5");
  };

  const handleCancel = () => {
      window.location = "https://www.ciccolombia.travel/public/default.aspx";
  };

  useEffect(() => {
    if (type === null) {
      setContainerClass("containerBody");
      setBackgroundClass("backgroundDark");
      setColComponent("col-12 col-md-6");
    }
  }, [type]);

  return (
    <div className="black-b">

      <Header />

      <div className={`${containerClass}`}>
      </div>

      <div className="container-fluid d-flex justify-content-center align-items-center" style={{ minHeight: '85vh' }}>
        <div className={`${colComponent}`}>
          <div className={`card o-hidden border-0 shadow-lg my-5 ${backgroundClass}`}>
            <div className="card-body p-4">
              <div className="card-body justify-center">
                {type == null ? (
                  <>
                    <h2 className="bg-transparent text-center">
                      Selecciona el Tipo de Persona
                    </h2>
                    <div className="d-flex flex-column flex-sm-row justify-center mt-3">
                      <div className="col justify-content-center">
                        <div
                          className=" "
                          onClick={(e) => {
                            selectedType("NATURAL");
                          }}
                        >
                          <div className="card-body text-center">
                            <img src="/natural.svg" width="100px" className="imgMenu" alt="natural" />
                            <h5 className="card-title mt-3">Persona Natural</h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-auto"></div>
                      <div className="col d-flex justify-content-center">
                        {" "}
                        <div
                          onClick={(e) => {
                            selectedType("JURIDICA");
                          }}
                        >
                          <div className="card-body text-center">
                            <img src="/juridica.svg" width="118px" className="imgMenu" alt="business" />
                            <h5 className="card-title mt-3">
                              Persona Juridica
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-center">
                      <Button variant="danger" className="p-3 col-sm-4 col-10 mt-2" style={{ borderRadius: "50px" }} onClick={handleCancel}>
                        Cancelar
                      </Button>
                    </div>
                  </>
                ) : type == "JURIDICA" ? (
                  <SarlaftPJuridica
                    onCancel={() => {
                      selectedType(null);
                    }}
                  ></SarlaftPJuridica>
                ) : (
                  <SarlaftPNatural
                    onCancel={() => {
                      selectedType(null);
                    }}
                  ></SarlaftPNatural>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
     
      <Footer />
    </div >

  );
};

const mapStateToProps = (state) => {
  return {
    loginState: state.loginState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginForm: (data) =>
      dispatch({
        type: "LOGIN_REQUEST",
        data,
      }),
    loginReset: () =>
      dispatch({
        type: "LOGIN_RESET",
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sarlaft);
